import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EcoBundle2 from 'eco-design/sections/eco-bundle-2';
import useProductInfo from '@/utils/hooks/useProductInfo';
import { useMemo } from 'react';
import { data1, data2, data3 } from './data';
import { useShoppingCart } from '@elem/compPage/glacier-classic-portable-refrigerator/useShoppingCart';
import gtm from '@/utils/gtm';

export default function JP_Bundles() {
    const { t } = useLang('theProduct.bundles');

    const getInfo = (i: any, idx: number, listName: string) => {
        const discount = Math.round((1 - i.price / (i.compareAtPrice || i.price)) * 100);
        const title = i.skuTitle === 'Default Title' ? i.productTitle : i.skuTitle;
        return {
            lChildren: i.inventoryQuantity <= 0 ? t('btn3') : t('btn1'),
            lDisabled: i.inventoryQuantity <= 0,
            lRadius: 'ellipse',
            rChildren: i.inventoryQuantity <= 0 ? '' : t('btn2'),
            rRadius: 'ellipse',
            rType: 'outlined',
            pointsTextL: '倍',
            pointsTimes: 5,

            title,
            desc: t(`p${idx + 1}`),
            price: i.price,
            comparePrice: i.compareAtPrice > i.price ? i.compareAtPrice : null,
            rDisabled: i.inventoryQuantity <= 0,
            lBtnClick() {
                handleAddCart([
                    {
                        originalPrice: i.compareAtPrice,
                        discountPrice: i.price,
                        img: i.variantImg,
                        productImg: i.img,
                        title,
                        productId: i.productId,
                        variantId: i.variantId,
                        quantity: 1,
                        inventory: i.inventoryQuantity,
                    },
                ]);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_add_to_cart',
                    list_name: listName,
                    price: i.price,
                    product_name: title,
                    tag: 'none',
                    quantity: 1,
                    button_name: t('btn1'),
                });
            },
            rHref: `https://jp.ecoflow.com/cart/${i.variantId}:1?channel=buy_button`,
            rDataLayer: {
                event: 'uaEvent',
                event_name: 'checkout',
                button_name: `${t('btn2')}_${title}`,
            },
            discountTextL: i.price && discount > 0 ? `${discount}% OFF` : '',
        };
    };

    const list1 = useProductInfo(data1);
    const items1 = useMemo(
        () =>
            list1.map((i) => ({
                imgs: [{ pc: i.variantImg }, { pc: '' }],
                info: getInfo(i, 0, t('card1_title')),
            })),
        [list1],
    );
    const list2 = useProductInfo(data2);
    const items2 = useMemo(
        () =>
            list2.map((i) => ({
                imgs: [{ pc: i.variantImg }, { pc: '' }],
                info: getInfo(i, 1, t('card2_title')),
            })),
        [list2],
    );
    const list3 = useProductInfo(data3);
    const items3 = useMemo(
        () =>
            list3.map((i, idx) => ({
                imgs: [{ pc: i.variantImg }, { pc: '' }],
                info: getInfo(i, idx + 2, t('card3_title')),
            })),
        [list3],
    );

    /** 购物车 */
    const { Comp, handleAddCart } = useShoppingCart();

    return (
        <div className={styles.bundles}>
            <EcoBundle2 items={items1} section={{ title: t('card1_title') }} />
            <EcoBundle2 items={items2} section={{ title: t('card2_title') }} />
            <EcoBundle2 items={items3} section={{ title: t('card3_title') }} />
            {Comp}
        </div>
    );
}
